import React, { useEffect, useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [countries, setCountries] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);
  const [num1, setNum1] = useState(Math.floor(Math.random() * 10));
  const [num2, setNum2] = useState(Math.floor(Math.random() * 10));
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch(
          "https://restcountries.com/v2/all?fields=name,alpha2Code,callingCodes"
        );
        const data = await res.json();

        if (!Array.isArray(data)) throw new Error("Invalid country list");

        const sortedCountries = data
          .map((country) => ({
            name: country.name,
            code: country.alpha2Code,
            callingCode: country.callingCodes?.[0] || "",
          }))
          .sort((a, b) => a.name.localeCompare(b.name));

        setCountries(sortedCountries);
        setCountryCodes(sortedCountries.filter((c) => c.callingCode));
      } catch (error) {
        console.error("Country fetch failed:", error);
      }
    };

    fetchCountries();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (parseInt(captchaAnswer) !== num1 + num2) {
      alert("Captcha incorrect! Please try again.");
      return;
    }
    alert("Form submitted successfully!");
  };

  return (
    <div className="contact-page">
      <div className="faq-header">
        <h1>Contact us</h1>
        <p>
          Please feel free to contact us for any query related to our products
          and services. We assure you the best quality products at reasonable
          prices.
        </p>
      </div>

      <div className="contact-main">
        {/* Left Side */}
        <div className="left-section">
          <h2>Get In Touch</h2>
          <p>
           Stay updated — follow us on social media.
          </p>

          <div className="social-icons">
            <a
              href="https://www.instagram.com/iindvo/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="http://linkedin.com/company/indvo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.facebook.com/iIndvo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.youtube.com/@iINDVO"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://wa.me/919407861249?text=Hello%20Indvo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>

          <h2>Send Us A Message</h2>
          <p className="small-note">
            For any queries related to our services and sourcing.
          </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            {/* Row: Full Name, Email, Mobile, Country */}
            <div className="input-row">
              <div>
                <label>Full Name *</label>
                <input type="text" required placeholder="Your full name" />
              </div>

              <div>
                <label>Email *</label>
                <input type="email" required placeholder="you@example.com" />
              </div>

              <div>
                <label>Mobile Number *</label>
                <div className="mobile-input">
                  <input
                    type="tel"
                    required
                    placeholder="Mobile number"
                    className="phone-number"
                  />
                </div>
              </div>

              <div>
                <label>Company Name (optional)</label>
                <input type="text" placeholder="eg. Ubikon" />
              </div>

              <div>
                <label>Which country do you reside in? *</label>
                <select required>
                  <option value="">-- Please select --</option>
                  {countries.length > 0 ? (
                    countries.map((country) => (
                      <option key={country.code} value={country.code}>
                        {country.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>Loading countries...</option>
                  )}
                </select>
              </div>
            </div>

            {/* Service Dropdown */}
            <label>Service Required *</label>
            <select required>
              <option value="">-- Select Service --</option>
              <option value="expand">Expand</option>
              <option value="sourcing">Sourcing</option>
            </select>

            <label>Product Description</label>
            <textarea
              rows="4"
              placeholder="Tell us more about your product requirements..."
            ></textarea>

            {/* Math Captcha */}
            <div className="captcha-box">
              <label>
                Solve this to verify: {num1} + {num2} =
              </label>
              <input
                type="number"
                value={captchaAnswer}
                onChange={(e) => setCaptchaAnswer(e.target.value)}
                required
              />
            </div>

            <button type="submit">Submit</button>
          </form>
        </div>

        {/* Right Side */}
        <div className="right-section">
          <h2>Contact Detail</h2>
          <div className="contact-details">
            <p>
              <strong>📍 Address:</strong> Behind Mata Mandir, Krishi Farm Road,
              Chandangaon, Chhindwara, MP 480001
            </p>
            <p>
              <strong>📞 Phone:</strong> +91-9407861249
            </p>
            <p>
              <strong>📧 Email:</strong> Contact@indvo.com
            </p>
          </div>

          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3880579.25902345!2d77.98444621865295!3d23.368327696017925!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd568b4bb93b89b%3A0xfcbb71b8b1b1e41d!2sMaata%20Temple%20chandangaon!5e1!3m2!1sen!2sin!4v1753249305952!5m2!1sen!2sin"
              width="100%"
              height="600"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
